import React from 'react'
import PropTypes from 'prop-types'
import './ImageTextGroupComponent.css'

import ImageText from './ImageTextComponent'

const ImageTextGroupComponent = (props) => {
	const items = props.content[props.contentGroupName].map((item, index) => <ImageText key={index} text={item.text} image={item.image} direction={props.itemDirection} startWith={props.startWith}/>)

	return (
		<div className={'ImageTextGroupComponent ' + props.groupDirection + ' ' + props.special}>
			{items}
		</div>
	)
}

ImageTextGroupComponent.propTypes = {
	content: PropTypes.object.isRequired,
	groupDirection: PropTypes.oneOf(['row', 'column']).isRequired,
	itemDirection: PropTypes.oneOf(['row', 'column']).isRequired,
	startWith: PropTypes.oneOf(['text', 'image']).isRequired,
	contentGroupName: PropTypes.string.isRequired,
	special: PropTypes.oneOf(['flip-flop', ''])
}

ImageTextGroupComponent.defaultProps = {
	special: ''
}

export default ImageTextGroupComponent


// WEBPACK FOOTER //
// ./src/components/ImageTextGroupComponent/ImageTextGroupComponent.js